import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const BlogCard = ({ blog, onClick }) => (
  <Box
    onClick={onClick}
    sx={{
      borderRadius: '18px',
      overflow: 'hidden',
      border: '1px solid var(--border-l)',
      bgcolor: '#fff',
      cursor: 'pointer',
      transition: 'all 0.35s cubic-bezier(0.23,1,0.32,1)',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      boxShadow: '0 4px 20px rgba(21,42,30,0.05)',
      '&:hover': {
        boxShadow: '0 12px 48px rgba(21,42,30,0.1)',
        transform: 'translateY(-5px)',
        borderColor: 'var(--sage-p)',
      },
    }}
  >
    {/* Banner with emoji */}
    <Box
      sx={{
        height: 140,
        background: blog.bg,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 32,
        lineHeight: 1,
      }}
    >
      {blog.icon}
    </Box>

    {/* Body */}
    <Box
      sx={{
        p: 2.25,
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
      }}
    >
      {/* Category eyebrow with dash */}
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 1,
          mb: 1.25,
          lineHeight: 1,
        }}
      >
        <Box sx={{ width: 18, height: '1.5px', bgcolor: 'var(--sage)', flexShrink: 0 }} />
        <Typography
          component="span"
          sx={{
            fontSize: 10,
            fontWeight: 700,
            letterSpacing: '0.16em',
            textTransform: 'uppercase',
            color: 'var(--sage)',
            lineHeight: 1,
          }}
        >
          {blog.category}
        </Typography>
      </Box>

      {/* Title */}
      <Typography
        className="serif"
        sx={{
          fontSize: 16,
          fontWeight: 600,
          color: 'var(--ink)',
          lineHeight: 1.35,
          mb: 1.5,
          flex: 1,
        }}
      >
        {blog.title}
      </Typography>

      {/* Meta */}
      <Typography
        sx={{
          fontSize: 12,
          color: 'var(--stone)',
          fontWeight: 400,
          lineHeight: 1.4,
        }}
      >
        {blog.author} &nbsp;·&nbsp; {blog.readTime} read &nbsp;·&nbsp; {blog.date}
      </Typography>
    </Box>
  </Box>
);

export default BlogCard;
